import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:3004',
});

api.interceptors.request.use(config => {
  const token = sessionStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  res => res,
  err => {
    if (err.response?.status === 401) {
      const tokenAtual = sessionStorage.getItem('token');
      const tokenRequisicao = err.config?.headers?.Authorization?.replace('Bearer ', '');
      if (tokenAtual && tokenRequisicao === tokenAtual) {
        sessionStorage.removeItem('token');
        sessionStorage.removeItem('usuario');
        window.dispatchEvent(new Event('auth-logout'));
      }
    }
    if (err.response?.status === 403) {
      const mensagem = err.response?.data?.mensagem || '';
      if (mensagem.includes('suspensa') || mensagem.includes('venceu') || mensagem.includes('cancelado')) {
        window.dispatchEvent(new CustomEvent('conta-suspensa', { detail: { mensagem } }));
      }
    }
    return Promise.reject(err);
  }
);

export default api;
